<div class="ContentInfo">
  <div class="ContentInfo-header d-flex flex-row">
    <div
      class="ContentInfo-header-title flex-grow-1 d-flex flex-row align-items-center">
      <div class="flex-grow-1">
        <div class="Breadcrumbs">
          <div class="Breadcrumbs-items">
            <a [routerLink]="['/contents', 'content_group']"
              ><mat-icon class="Breadcrumbs-icon back"
                >keyboard_backspace</mat-icon
              ></a
            >
            <a
              class="Breadcrumbs-item first"
              [routerLink]="['/contents', 'content_group']"
              >Content Groups</a
            >
            <mat-icon class="Breadcrumbs-icon">chevron_right</mat-icon>
            <span class="Breadcrumbs-item">{{ contentGroupName }}</span>
          </div>
        </div>
      </div>
      <div class="flex-grow-0">
        <app-button
          [text]="getEditButtonProperties().text"
          [size]="getEditButtonProperties().size"
          [color]="getEditButtonProperties().color"
          [route]="getEditButtonProperties().route"></app-button>
      </div>
    </div>
  </div>
  <div class="ContentInfo-table">
    <app-table
      *ngIf="tableReady"
      [columns]="tableColumns"
      [dataSource]="dataSource"
      [dataSourceParams]="tableDataSourceParams"></app-table>
  </div>
</div>
